// Token-modell för mobil-kalkylatorns uttryck.
//
// Uttrycket lagras som en lista av Atom (numeriska/funktionella entiteter).
// Strukturella nodtyper (paren, sup, sqrt, frac, nthroot, fn) har egna
// barn-listor — de är därmed implicit ett träd. Cursor bor på en specifik
// path: (atomList-referens, index). När man klickar på en sub-grupp flyttas
// cursor in i dess inre lista.
//
// Renderaren genererar både LaTeX (för KaTeX-rendering vid behov) och JSX
// (för klickbara spans). Eval-funktionen parser om till AST.

export type AtomId = string;

export type Atom =
  | { id: AtomId; kind: "num"; v: string } // tal-sträng, t.ex. "12.5"
  | { id: AtomId; kind: "op"; v: "+" | "-" | "*" | "/" }
  | { id: AtomId; kind: "const"; name: "pi" | "e" }
  | { id: AtomId; kind: "comma" }
  | { id: AtomId; kind: "paren"; inner: Atom[] }
  | { id: AtomId; kind: "abs"; inner: Atom[] }
  | { id: AtomId; kind: "sqrt"; inner: Atom[] }
  | { id: AtomId; kind: "nthroot"; degree: Atom[]; inner: Atom[] }
  | { id: AtomId; kind: "frac"; num: Atom[]; den: Atom[] }
  | { id: AtomId; kind: "sup"; base: Atom[]; exp: Atom[] } // a^b — base är vanligen ett enkelt tal/paren
  | {
      id: AtomId;
      kind: "fn";
      name:
        | "sin"
        | "cos"
        | "tan"
        | "asin"
        | "acos"
        | "atan"
        | "ln"
        | "lg"
        | "log";
      arg: Atom[];
    }
  | { id: AtomId; kind: "logbase"; base: Atom[]; arg: Atom[] } // log_a(b)
  | { id: AtomId; kind: "fact"; inner: Atom[] } // n! — fakultet
  | {
      id: AtomId;
      kind: "binom";
      n: Atom[];
      r: Atom[];
      binomTyp: "ncr" | "npr";
    }; // n över r resp n permuterat r

let idCounter = 0;
export function newId(): string {
  idCounter += 1;
  return `a${idCounter}`;
}

export interface Cursor {
  /** path of "container ids" (ex: parent's inner-atom-ids in order). */
  path: AtomId[]; // empty path = root
  index: number; // position 0..list.length (mellanrum mellan atomer)
}

export type Mode = "deg" | "rad";
